<template>
  <div v-if="items.length > 0" class="d-flex align-center flex-wrap">
    <v-chip
      v-for="(item, index) in items.slice(0, limit)"
      small
      outlined
      color="blue-grey lighten-2"
      class="caption blue-grey--text text--darken-3 me-1 mb-1 chip"
      :key="`${item}${index}`"
    >
      {{ item.name || item }}
    </v-chip>
    <template v-if="itemsLength > limit">
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            v-on="on"
            small
            outlined
            color="blue-grey lighten-2"
            class="caption blue-grey--text text--darken-3 mb-1"
          >
            +{{ itemsLength - limit }}
          </v-chip>
        </template>

        <v-card
          class="ma-0 pa-0 blue-grey lighten-3 px-4 pt-4 pb-1 item-detail"
          dense
          elevation="2"
        >
          <p
            v-for="(item, index) in itemsToShow"
            class="ma-0 pa-0 label mb-3 blue-grey--text text--darken-2 font-weight-400"
            :key="`${item}${index}`"
          >
            {{ item }}
          </p>
        </v-card>
      </v-menu>
    </template>
  </div>
  <div v-else class="blue-grey--tex text-start">-</div>
</template>

<script>
export default {
  name: 'ChipList',

  props: {
    totalItems: Number,
    items: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      required: false,
      default: 1,
    },
  },

  computed: {
    itemsLength() {
      return this.totalItems ?? this.items.length
    },
    itemsToShow() {
      return this.items
    },
  },
}
</script>
<style lang="scss">
.item-detail {
  max-height: 250px;
  overflow-y: scroll;
  border: 1px solid var(--v-blue-grey-lighten1) !important;
}
.chip:hover {
  background-color: transparent !important;
}
</style>
